import { useCallback, useState, useEffect, useRef } from 'react';
import type { Dispatch, SetStateAction } from 'react';

const useSafeState: <S>(
  initialState: S | (() => S),
) => readonly [S, Dispatch<SetStateAction<S>>] = (initialState) => {
  const unmountedRef = useRef(false);
  const [state, setState] = useState(initialState);

  useEffect(() => {
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
    };
  }, []);

  const setCurrentState = useCallback((currentState) => {
    // 如果组件已卸载 停止更新
    if (unmountedRef.current) return;
    setState(currentState);
  }, []);

  return [state, setCurrentState] as const;
};

export default useSafeState;
